/**
 * Converts a CSP directive object to a string
 * @param directives - Object containing CSP directives
 * @returns - String representation of the CSP directives
 */
export const createCspString = (directives: Record<string, string[]>) => {
  return Object.entries(directives)
    .map(([key, value]) => `${key} ${value.join(' ')}`)
    .join('; ');
};
